import { regions, years } from "@/lib/movieData";

interface FilterPanelProps {
  region: string;
  year: string;
  sort: string;
  onChange: (patch: { region?: string; year?: string; sort?: string }) => void;
}

const sortOptions = [
  { value: "latest", label: "最新上映" },
  { value: "popular", label: "热门度" },
  { value: "rating", label: "评分优先" },
];

function OptionButton({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`h-8 px-3.5 rounded-full text-xs transition-colors whitespace-nowrap cursor-pointer ${
        active
          ? "bg-primary-500 text-background-50"
          : "bg-background-100 text-foreground-600 hover:bg-background-200"
      }`}
    >
      {label}
    </button>
  );
}

export default function FilterPanel({ region, year, sort, onChange }: FilterPanelProps) {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <span className="w-14 shrink-0 text-xs text-foreground-500">地区</span>
        <div className="flex flex-wrap gap-2">
          {regions.map((item) => (
            <OptionButton
              key={item}
              label={item}
              active={region === item}
              onClick={() => onChange({ region: item })}
            />
          ))}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <span className="w-14 shrink-0 text-xs text-foreground-500">年份</span>
        <div className="flex flex-wrap gap-2">
          {years.map((item) => (
            <OptionButton
              key={item}
              label={item}
              active={year === item}
              onClick={() => onChange({ year: item })}
            />
          ))}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <span className="w-14 shrink-0 text-xs text-foreground-500">排序</span>
        <div className="flex flex-wrap gap-2">
          {sortOptions.map((item) => (
            <OptionButton
              key={item.value}
              label={item.label}
              active={sort === item.value}
              onClick={() => onChange({ sort: item.value })}
            />
          ))}
        </div>
      </div>
    </div>
  );
}